export const LABELS_SCHEDULE_EXECUTION = {
    time: 'Час початку роботи на маршруті, год',
    arrivalTime: 'Час закінчення роботи на маршруті, год',
    departureTime: "Час початку роботи на маршруті, год",
    arrivalTimeFact: "Час закінчення роботи на маршруті, год(факт)",
    plannedCirclesCount: "Кількість рейсів(план)",
    circlesCount: "Кількість рейсів",
    realCirclesCount: "Кількість рейсів(факт)",
    plannedToRealCirclesPercent: " В-них рейсів, %",
    totalPointsPassed: "Кількість зупинок(факт)",
    pointsPassedInTime: "Кількість зупинок(по графіку)",
    percentPointsPassedInTime: "Графічність, %",
    plannedDepartureTime: "Час початку роботи на маршруті, год(план)",
    plannedArrivalTime: "Час закінчення роботи на маршруті, год(план)",
    plannedDuration: "Тривалість роботи на маршруті, год(план)",
    factDuration: "Тривалість роботи на маршруті, год(факт)",
    duration: "Тривалість роботи на маршруті",
    plannedPoints: "Кількість зупинок(план)",
    points: "Кількість зупинок",
    skippedPoints: "Пропущено зупинок",
    skippedCircles: "Пропущено рейсів",

}
